import BaseFormPresenter from "../../../base/BaseFormPresenter";
import { restUseCase } from "../../../usecases/rest";

class FollowUpFormPresenter extends BaseFormPresenter {

    generateBody(body, client){
        return `
        <html>
            <body style="font-family: Arial, sans-serif; color: #000;">
                <p>Dear ${client.name},</p>
                <p>${body}</p>
            </body>
        </html>
    `
    }

    async save() {
        const collection = this.view.getCollectionName();
        if (this.object.id) {
            this.change.id = this.object.id;
        }

        this.change.inquiry = { id: this.view.state.inq }

        console.log("send:", this.change);

        try {
            const inquiryId = this.view.state.inq;
            const inquiry = await this.getObjectUseCase.execute("inquiries", inquiryId, {
                params: { include: ["client"] }
            });
            const client = inquiry?.client?.name
            const email = inquiry?.client?.email_address;

            if (email) {
                const method = "POST";
                const path = "/send-email/a66266bc-0ea4-463d-b298-4c827b9cc829";
                const emailObj = {
                    to: email,
                    subject: this.change.subject || "Follow-Up Notification",
                    body: this.generateBody(this.change.body || "You've received a new follow-up.", client)
                };

                await restUseCase().execute(method, path, { body: emailObj });
                console.log("Email sent to:", email);
            } else {
                console.warn("No client email found for inquiry:", inquiryId);
            }

            await this.upsertUseCase.execute(collection, this.change);
            this.change = {};
            this.view.navigateBack();

        } catch (error) {
            console.error("Error in save():", error);
            throw error;
        }
    }


    async submit() {
        if (Object.values(this.change).length === 0) {
            this.view.showSuccessSnackbar("Successfully saved!");
            return;
        }
        try {
            this.view.submitting();
            await this.save();
            this.view.submissionSuccess();
            this.view.showSuccessSnackbar("Successfully saved!");
        } catch (error) {
            this.view.submissionError(error);
            this.view.showError(error);
        }
    }

}

export default FollowUpFormPresenter;
